import { GeneralCommonsModule } from '@/src/app/shared/modules/general-commons/general-commons.module';
import { CommonModule, AsyncPipe } from '@angular/common';
import { Component, NgModule, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ReportConfig } from '../../components/report-filters/models/report-filters.model';
import { ReportFiltersModule, ReportFiltersComponent } from '../../components/report-filters/report-filters.component';
import { ReportTableDataService } from '../../components/report-filters/services/report-table-data.service';
import { ReportService } from '../../components/report-filters/services/report.service';
import { ReportHeaderComponent } from '../../components/report-header/report-header.component';
import {
  QaOrthoCasesReportTableComponentModule,
  QaOrthoCasesReportTableComponent
} from './components/qa-ortho-cases-report-table/qa-ortho-cases-report-table.component';
import { PaginationSortingModel } from '@shared/components/table/models/pagination-sorting.model';
import { GenericPageComponent } from '@shared/modules/general-commons/components/generic-page/generic-page.component';

@Component({
  selector: 'stx-qa-ortho-cases',
  templateUrl: './qa-ortho-cases.component.html',
  imports: [
    GenericPageComponent,
    ReportHeaderComponent,
    ReportFiltersComponent,
    QaOrthoCasesReportTableComponent,
    AsyncPipe,
    TranslateModule
  ]
})
export class QaOrthoCasesComponent {
  reportService = inject(ReportService);
  private reportTableDataService = inject(ReportTableDataService);

  readonly reportConfig: ReportConfig = {
    type: 'QA_ORTHO_CASES',
    downloadOptions: {
      excel: true
    },
    filters: {
      date: true,
      geography: true,
      organizationsTree: true,
      orthodontists: true,
      reviewers: true
    }
  };

  applyFilters(pagination: PaginationSortingModel) {
    this.reportTableDataService.prepareList(this.reportConfig.type, this.reportService.model, pagination);
  }
}

@NgModule({
  imports: [
    CommonModule,
    QaOrthoCasesReportTableComponentModule,
    ReportFiltersModule,
    TranslateModule,
    GeneralCommonsModule,
    QaOrthoCasesComponent
  ],
  exports: [QaOrthoCasesComponent]
})
export class QaOrthoCasesComponentModule {}
